// Real-time number formatter utility
// Handles comma/dot prefixed number auto-correction

export const formatNumberInput = (inputValue, inputElement) => {
  if (!inputValue || typeof inputValue !== 'string') {
    return inputValue;
  }

  // Pattern to match comma or dot followed by digits (e.g., ".1", ",25", ".567")
  const prefixPattern = /^[,.]\d+$/;
  
  if (prefixPattern.test(inputValue)) {
    const correctedValue = inputValue.startsWith(',') 
      ? '0,' + inputValue.substring(1)
      : '0.' + inputValue.substring(1);
    
    // Update cursor position to maintain user experience
    if (inputElement) {
      const cursorPosition = inputElement.selectionStart;
      // Set the corrected value
      setTimeout(() => {
        inputElement.value = correctedValue;
        // Adjust cursor position (add 1 for the added '0')
        inputElement.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
      }, 0);
    }
    
    return correctedValue;
  }

  return inputValue;
};

export const handleNumberInput = (event, vModelSetter) => {
  const inputElement = event.target;
  const inputValue = inputElement.value;
  
  const formattedValue = formatNumberInput(inputValue, inputElement);
  
  if (formattedValue !== inputValue) {
    // Update the v-model
    vModelSetter(formattedValue);
  }
};